import React, { useState} from 'react';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Rating } from 'primereact/rating';
//import './DataViewDemo.css';

//showaveragenumber
import {showAverageNumber} from '../../functions/ratings'

//css
import 'primereact/resources/themes/saga-orange/theme.css' 
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';


//import './App.css'
//import './App.scss';

import './DataView.scss';




import {Link} from 'react-router-dom';
//import _ from 'lodash'

const ProductItems = ({products, handleAddToChart}) => {
    const [layout, setLayout] = useState('list');
    const [sortKey, setSortKey] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [sortField, setSortField] = useState(null);
    const sortOptions = [
        {label: 'Price High to Low', value: '!price'},
        {label: 'Price Low to High', value: 'price'},
    ];

    //lazy features added 

   


  


    const onSortChange = (event) => {
        const value = event.value;

        if (value.indexOf('!') === 0) {
            setSortOrder(-1);
            setSortField(value.substring(1, value.length));
            setSortKey(value);
        }
        else {
            setSortOrder(1);
            setSortField(value);
            setSortKey(value);
        }
    }

    const handleInventoryStatus = (quantity)=>{
        let inventoryStatus = null;
        if (quantity < 1) {
          inventoryStatus = "OUTOFSTOCK";
        } else if (2 < quantity && quantity < 10) {
            inventoryStatus="LOWSTOCK"
        } else {
            inventoryStatus = "INSTOCK";
        }
        return(inventoryStatus)

    }



    const renderListItem = (data) => {

        const inventoryStatus=handleInventoryStatus(data.quantity)
        
        const rating =showAverageNumber(data)
        return (
          <div className="p-col-12">
            <div className="product-list-item">
              <Link
                to={`/product/${data.slug}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={
                    data.images && data.images.length
                      ? data.images[0].url
                      : "https://res.cloudinary.com/adebola19/image/upload/v1635163352/BOBZA/Products/NO_Images/no_image_found_ifdmet.jpg"
                  }
                  onError={(e) =>
                    (e.target.src =
                      "https://res.cloudinary.com/adebola19/image/upload/v1635163352/BOBZA/Products/NO_Images/no_image_found_ifdmet.jpg")
                  }
                  alt={data.title}
                />
              </Link>

              <div className="product-list-detail">
                <div className="product-name">
                  <Link
                    to={`/product/${data.slug}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="product-name"
                    style={{ color: "#000" }}
                  >
                    {data.title}
                  </Link>
                </div>
                <div className="product-description">{`${data.description &&
                  data.description.substring(0, 40)}...`}</div>
                <Rating value={rating} readOnly cancel={false}></Rating>
                <i className="pi pi-tag product-category-icon"></i>
                <span className="product-category">{data.category.name}</span>
              </div>
              <div className="product-list-action">
                <span className="product-price">R{data.price}</span>
                <Button
                  disabled={inventoryStatus === "OUTOFSTOCK"}
                  onClick={() => handleAddToChart(data)}
                >
                  <div className="p-text-nowrap-bold">Add to Cart</div>
                </Button>
                <span
                  className={`product-badge status-${inventoryStatus.toLowerCase()}`}
                >
                  {inventoryStatus}
                </span>
              </div>
            </div>
          </div>
        );
    }

    const renderGridItem = (data) => {
        const inventoryStatus=handleInventoryStatus(data.quantity)
        const rating =showAverageNumber(data)
        return (
          <div className="p-col-12 p-md-4">
            <div className="product-grid-item card">
              <div className="product-grid-item-top">
                <div>
                  <i className="pi pi-tag product-category-icon"></i>
                  <span className="product-category">{data.category.name}</span>
                </div>
                <span
                  className={`product-badge status-${inventoryStatus.toLowerCase()}`}
                >
                  {inventoryStatus}
                </span>
              </div>
              <div className="product-grid-item-content">
                <Link
                  to={`/product/${data.slug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={
                      data.images && data.images.length
                        ? data.images[0].url
                        : "https://res.cloudinary.com/adebola19/image/upload/v1635163352/BOBZA/Products/NO_Images/no_image_found_ifdmet.jpg"
                    }
                    onError={(e) =>
                      (e.target.src =
                        "https://res.cloudinary.com/adebola19/image/upload/v1635163352/BOBZA/Products/NO_Images/no_image_found_ifdmet.jpg")
                    }
                    alt={data.title}
                  />
                </Link>

                <div className="product-name">
                  <Link
                    to={`/product/${data.slug}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="product-name"
                    style={{ color: "#000" }}
                  >
                    {data.title}
                  </Link>
                </div>
                <div className="product-description">{`${data.description &&
                  data.description.substring(0, 25)}...`}</div>
                <Rating value={rating} readOnly cancel={false}></Rating>
              </div>
              <div className="product-grid-item-bottom">
                <span className="product-price">
                  <div className="p-text-nowrap-bold">R{data.price}</div>
                </span>
                <Button
                  className="p-button-sm"
                  disabled={inventoryStatus === "OUTOFSTOCK"}
                  onClick={() => handleAddToChart(data)}
                >
                  <div className="p-text-nowrap-bold">Add to Cart</div>
                </Button>
              </div>
              <br />
            </div>
          </div>
        );
    }

    const itemTemplate = (product, layout) => {
        if (!product) {
            return;
        }

        if (layout === 'list')
            return renderListItem(product);
        else if (layout === 'grid')
            return renderGridItem(product);
    }

    const renderHeader = () => {
        return (
            <div className="p-grid p-nogutter">
                <div className="p-col-6" style={{textAlign: 'left'}}>
                    <Dropdown options={sortOptions} value={sortKey} optionLabel="label" placeholder="Sort By Price" onChange={onSortChange}/>
                </div>
                <div className="p-col-6" style={{textAlign: 'right'}}>
                    <DataViewLayoutOptions layout={layout} onChange={(e) => setLayout(e.value)}  />
                </div>
            </div>
        );
    }

    const header = renderHeader();

    return (
        <div className="grid list-demo">
            <div className="card">
                <DataView value={products} layout={layout} header={header}
                        itemTemplate={itemTemplate} paginator rows={9}
                        sortOrder={sortOrder} sortField={sortField} />
            </div>
        </div>
    );
}

export default ProductItems;